export default "__VITE_ASSET__CmmZg$Rr__"